import React from 'react';
import { fmt, isNum, EM_DASH } from '../../utils/format.js';

// This renders inside the fixture's <Card.Title> on every render path, so an
// exception here white-screens the whole page rather than one card.
//
// Commit 6dc0e5c fixed the reported crash by guarding `fixture.ratings`, which
// was only half of it: `ratings` can be present while `home_pre_elo` is null,
// and after the hydration change to null defaults it routinely will be. Guards
// here are on the value, not the blob.

// "12-4-1", or an em-dash for whichever component we do not have. A record built
// from undefined used to render literally as "(undefined-undefined-undefined)".
const record = (...parts) =>
  parts.map((part) => (isNum(part) ? String(part) : EM_DASH)).join('-');

const elo = (rating) => {
  const text = fmt(rating, 0);
  return text === EM_DASH ? ' ' : `(${text}) `;
};

const Versus = ({ fixture }) => {
  if (!fixture) return null;

  const stats = fixture.stats;
  const ratings = fixture.ratings;

  if (isSupportedSport(fixture) && stats) {
    return (
      <span>
        {`${fixture.home_team}(${record(stats.home_wins, stats.home_losses, stats.home_draws)})${elo(ratings?.home_pre_elo)}`}
        vs{' '}
        {`${fixture.away_team}(${record(stats.away_wins, stats.away_losses, stats.away_draws)})${elo(ratings?.away_pre_elo).trimEnd()}`}
      </span>
    );
  }

  if (stats) {
    return (
      <span>
        {`${fixture.home_team}(${record(stats.home_wins, stats.home_losses)})${elo(ratings?.home_pre_elo)}`}
        vs{' '}
        {`${fixture.away_team}(${record(stats.away_wins, stats.away_losses)})${elo(ratings?.away_pre_elo).trimEnd()}`}
      </span>
    );
  }

  return (
    <span>
      {fixture.home_team} vs {fixture.away_team}
    </span>
  );
};

function isSupportedSport(fixture) {
  const supportedSports = ["Hockey", "Soccer", "RugbyLeague", "AussieRules"];
  return supportedSports.includes(fixture.sport);
}
export default Versus;
